import { FormattedMessage } from 'react-intl';

import { Document } from '@/features/administration/components/Document';
import type { PersonalInfoCardProps } from '@/features/administration/types';

export const Documents = ({ documents }: PersonalInfoCardProps) => (
    <div className='display-flex flex-1-1-0 flex-column margin-bottom-15 rounded bg-white'>
        <div className='text-size-18 text-bold margin-bottom-15'>
            <FormattedMessage id='chargingContract.documents.title' />
        </div>
        <span>
            <FormattedMessage id='chargingContract.documents.description' />
        </span>
        <div className='margin-top-10'>
            {documents.map(document => (
                <div key={document.documentType} className='margin-top-5'>
                    <Document {...document} />
                </div>
            ))}
        </div>
    </div>
);
